import { styled, Typography, IconButton, Tooltip, Box } from "@mui/material";
import React from "react";
import { Button, FlexRow } from "../../components";
import { MdRefresh } from "react-icons/md";
import { FaSpinner } from "react-icons/fa";

// Add keyframes for spinner animation
const spinKeyframes = `
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const Wrapper = styled(FlexRow)`
  width: 100%;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px 15px 0px;
`;

export const StyledPrimaryButton = styled(Button)`
  min-width: 0;
  min-height: 32px;
  padding: 0px 10px;
  border-radius: 5px;
  color: ${({ theme }) => theme.palette.colors.gray["900"]};
`;

interface HomeScreenHeaderProps {
  onRefresh?: () => void;
  refreshing?: boolean;
}

const HomeScreenHeader = ({ onRefresh, refreshing }: HomeScreenHeaderProps) => {
  return (
    <>
      <style>{spinKeyframes}</style>
      <Wrapper>
        <Typography
          variant="h4"
          gutterBottom
          component="div"
          sx={{ fontWeight: "bold", color: "primary.main" }}
        >
          Dashboard Overview
        </Typography>
      
      {onRefresh && (
        <Tooltip title="Refresh Dashboard Data" arrow>
          <IconButton 
            onClick={onRefresh} 
            disabled={refreshing}
            sx={{ 
              bgcolor: "primary.main",
              color: "white",
              width: 44,
              height: 44,
              borderRadius: 2,
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              "&:hover": { 
                bgcolor: "primary.dark",
                transform: "translateY(-2px)",
                boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
              },
              "&:active": {
                transform: "translateY(0px)",
              },
              "&:disabled": {
                bgcolor: "grey.300",
                color: "grey.500",
                transform: "none",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              },
              transition: "all 0.2s ease-in-out",
            }}
          >
            {refreshing ? (
              <FaSpinner 
                size={18} 
                style={{ 
                  animation: "spin 1s linear infinite" 
                }} 
              />
            ) : (
              <MdRefresh size={18} />
            )}
          </IconButton>
        </Tooltip>
      )}
      </Wrapper>
    </>
  );
};

export default HomeScreenHeader;
